
import { getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import Paginator from '@/views/components/paginator/Paginator.vue'
import ProgressSpinner from 'primevue/progressspinner'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import moment from 'moment'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'

export default {
  components: {
    DataTable,
    Column,
    Paginator,
    ProgressSpinner,
    InputIconRight,
    Button,
    HjpConfirmationModal
  },
  props: {
    ritList: {
      default: () => []
    }
  },
  emits: ['showCloseRitDialog', 'reloadHeader'],
  setup(props: any, { emit }: any) {
    const transactionRitEndpoint = '/transaction/v1/Rit'
    const transactionControlEndpoint = '/transaction/v1/Control'
    const app = getCurrentInstance()
    const {
      $icon, $toast
    } = app!.appContext.config.globalProperties
    const icon = $icon
    const { ritList } = toRefs(props)
    const store = useStore()
    const inputSearch = ref('')
    const selectedRitId = ref(null) as any
    const selectedConrollerData = ref(null) as any
    const dataSource = ref([]) as any
    const filters = {
      search: '',
      filterField: ['code'] as any,
      pageSize: 10,
      pageNumber: 1,
      custom: [] as any,
      totalRecords: 0
    }

    const attrModalConfirmation = reactive({
      show: false,
      title: 'Turunkan Kontroler?',
      subTitle: 'Pastikan kontroler yang akan Anda turunkan sudah benar-benar keluar dari bus!',
      btnSubmitTitle: 'Turunkan Kontroler',
      imgContent: require('@/assets/img/modal-confirmation/dropoff-controller.svg')
    })

    const getAllRitTicketData = async () => {
      store.dispatch('showLoading')
      await apiUseCase.get(`${transactionRitEndpoint}/${selectedRitId.value}/Tickets${returnUrlPrams(filters)}`).then((response) => {
        const {
          error,
          result,
          count
        } = response
        if (!error) {
          // console.log('result', result)
          dataSource.value = result
          filters.totalRecords = count
        }
        // console.log('dataSource', dataSource.value)
      })
      store.dispatch('hideLoading')
    }

    const selectedRitAct = (id: any) => {
      filters.pageNumber = 1
      if (selectedRitId.value === id) {
        selectedRitId.value = null
      } else {
        selectedRitId.value = id
        getAllRitTicketData()
      }
    }

    const onSearch = () => {
      // console.log('search', inputSearch.value)
      filters.search = inputSearch.value
      getAllRitTicketData()
    }

    const onChangePage = (val: any) => {
      // console.log('val', val)
      filters.pageNumber = val.page + 1
      getAllRitTicketData()
    }

    const hidedropOffController = () => {
      selectedConrollerData.value = null
      attrModalConfirmation.show = false
    }

    const dropOffControllerAct = async () => {
      store.dispatch('showLoading')
      const payload = {
        DropoffStationName: selectedConrollerData.value?.BoardStationName,
        DropoffVerbatim: 'Diturunkan oleh Admin'
      }
      try {
        await apiUseCase.postWithNoId(`${transactionControlEndpoint}/${selectedConrollerData.value.Id}/Checkout`, payload).then((response) => {
          const { error, message } = response
          if (!error) {
            $toast.add({
              severity: 'success',
              detail: 'Kontroler berhasil diturunkan',
              group: 'bc',
              closable: false,
              life: 3000
            })
            // eslint-disable-next-line no-use-before-define
            hidedropOffController()
            getAllRitTicketData()
            // eslint-disable-next-line no-use-before-define
            reloadHeader()
            selectedConrollerData.value = null
          } else {
            $toast.add({
              severity: 'error',
              summary: 'Kontroler gagal diturunkan',
              detail: message,
              group: 'bc',
              closable: false,
              life: 3000
            })
          }
        })
      } catch (error) {
        $toast.add({
          severity: 'error',
          summary: 'Kontroler gagal diturunkan',
          detail: error,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
      store.dispatch('hideLoading')
    }

    const showCloseRitDialogAct = (id: any) => {
      emit('showCloseRitDialog', id)
    }

    const reloadHeader = () => {
      emit('reloadHeader')
    }

    return {
      icon,
      inputSearch,
      getAllRitTicketData,
      onSearch,
      ritList,
      dataSource,
      selectedRitId,
      selectedRitAct,
      filters,
      onChangePage,
      moment,
      attrModalConfirmation,
      hidedropOffController,
      selectedConrollerData,
      dropOffControllerAct,
      showCloseRitDialogAct,
      reloadHeader
    }
  }
}
